<div bsModal #newsatisfaction="bs-modal" id="newregular" class="modal fade" (onShown)="onShown()"  role="dialog" aria-labelledby="newsatisfaction" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center"><span class="capitalize">{{action}}</span> {{parentName}} question</h2>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Language:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <select #languageShortCode id="satisfactionLanguages" (change)="checkData(languageShortCode.value)">
                            <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Text:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <textarea (focusout)="addLocalization(text.value, languageShortCode.value)"
                                  (keypress)="preventSpace(text.value, $event)"
                                  (keyup)="preventSpace(text.value, $event)"
                                  id="satisfactionTextarea" class="" #text placeholder="Question body" cols="2" rows="2">{{text}}</textarea>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Level:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <select id="satLevels">
                            <option *ngFor="let level of levels;" [selected]="currentLevel == level" value="{{level}}">{{level}}</option>
                        </select>
                    </div>
                </div>

                <div class="row" *ngIf="type == 5">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Category:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <select id="levels" [(ngModel)]="category">
                            <option *ngFor="let cat of categories;" [selected]="category == cat.Id" value="{{cat.Id}}">{{cat.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Negatively Keyed:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <div class="checkbox" style="display: contents;">
                            <input (change)="changeNegativelyKeyedStatus()" id="satCheckbox2" type="checkbox" [checked]="negativelyKeyed">
                            <label for="satCheckbox2"></label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-3 noPadding">
                        <label>Test Question:</label>
                    </div>
                    <div class="col-12 col-md-9 noPadding">
                        <div class="checkbox" style="display: contents;">
                            <input (change)="changeTestQuestionStatus()" id="satCheckboxTest" type="checkbox" [checked]="testQuestion">
                            <label for="satCheckboxTest"></label>
                        </div>
                    </div>
                </div>

                <!--<div class="row">
        <div class="col-12">
            <label>Type:</label>
            <select>
                <option value="value">Fixed</option>
                <option value="value">Test</option>
                <option value="value">Random</option>
            </select>
        </div>
    </div>-->
            </div>

            <div class="modal-footer text-right">
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />

                <ng-container>
                    <input type="button" (click)="saveQuestion(text.value)" class="btn btn-primary waves-effect" value="Save" />
                </ng-container>
            </div>
        </div>
    </div>
</div>
